import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../../components/newsList';
import NewsBox from '../../../../components/newsBox';

class Fiction extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { fictionList, fictionBox },
        } = this.props;

        return (
            <Fragment>
                <Chip
                    id="255877"
                    type="recommend"
                    title="北京河北地区小说列表"
                    groupName="小说"
                    content={fictionList}
                    translate="handleNewsData">
                    <NewsList hasTitle size="long" />
                </Chip>
                <Chip
                    id="195877"
                    type="recommend"
                    title="北京河北地区小说新闻盒"
                    groupName="小说"
                    content={fictionBox}
                    translate="handleNewsBoxData">
                    <NewsBox />
                </Chip>
            </Fragment>
        );
    }
}

export default errorBoundary(Fiction);
